import { Component, ElementRef, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationService } from "src/app/Service/notification.service";
import { OtherService } from "src/app/Service/other.service";
import { registerables } from 'chart.js';
import Chart from 'chart.js/auto';
import axios from "src/app/Service/axios";
import { Location } from '@angular/common';
import Map from 'ol/Map';
import View from 'ol/View';
import * as olProj from 'ol/proj';
import {
  DragRotateAndZoom,
  defaults as defaultInteractions,
} from 'ol/interaction';
import Feature from 'ol/Feature';
import { Tile as TileLayer } from 'ol/layer';
import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";
import { BingMaps, Cluster, Vector, XYZ } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";
import SelectCluster from "ol-ext/interaction/SelectCluster";
import { Tile } from "ol/layer";
import { MapService } from "src/app/Service/map.service";
import { DeviceDetectorService } from "ngx-device-detector";
import { Circle, Fill, Stroke, Style, Text } from "ol/style";
import "ol/ol.css";
import * as XLSX from 'xlsx';
import zoomPlugin from 'chartjs-plugin-zoom';
import { getRelativePosition } from 'chart.js/helpers';
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { DataService } from "src/app/Service/data.service";
import { GurdServiceService } from "src/app/Service/gurd-service.service";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
declare let $: any;

@Component({

  selector: 'dashbordAdds',

  templateUrl: './dashbordAdds.component.html',

})

export class DashbordAddsComponent implements OnInit {

  constructor(private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private el: ElementRef,
    private _location: Location,
    private mapService: MapService,
    private deviceService: DeviceDetectorService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private gurdService: GurdServiceService
  ) {
    Chart.register(...registerables);
    Chart.register(zoomPlugin);
  }
  dataFrom: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });
  dataTo: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });
  modalData: any;
  carType: any;
  iMobileDomain: number = -1;
  clusterModal: any;
  domain: any;
  fileName = 'ExcelSheet.xlsx';
  carStatusData: any;
  JournalTypeData: any;
  close3: boolean = false;
  close2: boolean = false;
  close1: boolean = false;
  close4: boolean = false;
  close5: boolean = false;
  close6: boolean = false;
  close7: boolean = false;
  groupCar: any = [];
  listTaxiAdds: any;

  location: any = [51.3833554, 35.6770113];
  flon: any;
  flat: any;
  clusters: any;
  ctx1: any;
  ctx2: any;
  ctx3: any;
  ctx4: any;
  ctx7: any;
  ctx8: any;
  ctx9: any;
  ctx10: any;
  ctx11: any;
  ctx12: any;
  ctx15: any;
  ctx16: any;
  ctx17: any;
  ctx18: any;
  ctx19: any;
  obj: any;
  label: Array<any> = [];
  datachart: Array<any> = [];
  obj1: any;
  label1: Array<any> = [];
  datachart1: Array<any> = [];
  obj2: any;
  label2: Array<any> = [];
  datachart2: Array<any> = [];
  obj3: any;
  label3: Array<any> = [];
  datachart3: Array<any> = [];
  obj4: any;
  label4: Array<any> = [];
  datachart4: Array<any> = [];
  obj5: any;
  label5: Array<any> = [];
  datachart5: Array<any> = [];
  obj6: any;
  label6: Array<any> = [];
  datachart6: Array<any> = [];
  obj7: any;
  label7: Array<any> = [];
  datachart7: Array<any> = [];
  obj8: any;
  label8: Array<any> = [];
  datachart8: Array<any> = [];
  obj9: any;
  label9: Array<any> = [];
  datachart9: Array<any> = [];
  obj10: any;
  label10: Array<any> = [];
  datachart10: Array<any> = [];
  obj11: any;
  label11: Array<any> = [];
  datachart11: Array<any> = [];
  obj12: any;
  label12: Array<any> = [];
  datachart12: Array<any> = [];
  obj13: any;
  label13: Array<any> = [];
  datachart13: Array<any> = [];
  obj14: any;
  label14: Array<any> = [];
  datachart14: Array<any> = [];
  obj15: any;
  label15: Array<any> = [];
  datachart15: Array<any> = [];
  obj16: any;
  label16: Array<any> = [];
  datachart16: Array<any> = [];
  obj17: any;
  label17: Array<any> = [];
  datachart17: Array<any> = [];
  obj18: any;
  label18: Array<any> = [];
  datachart18: Array<any> = [];
  map: any = {};
  map2: any = {};
  map3: any = {};
  map4: any = {};
  isDesktop: any;
  tiMobileGroup: any = -1;
  tiGPSType: any = -1;
  taxiADS: any = -1;
  serviceAVGS: any;

  CHART_COLORS: any = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)',
  };
  CHART_COLORS2: any = {
    green: 'rgb(75, 192, 192)',
    purple: 'rgb(153, 102, 255)',
    blue: 'rgb(54, 162, 235)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    red: 'rgb(255, 99, 132)',
    grey: 'rgb(201, 203, 207)',
  };
  CHART_COLORS3: any = {
    green: 'rgb(111, 255, 111)',
    purple: 'rgb(255, 153, 204)',
    blue: 'rgb(29, 179, 214)',
    orange: 'rgb(45, 103, 103)',
    yellow: 'rgb(251, 101, 150)',
    red: 'rgb(36, 123, 46)',
    grey: 'rgb(103, 13, 183)',
  };

  source: any;

  source2: any;

  source3: any;

  source4: any;

  vector: any;

  vector2: any;

  vector3: any;

  vector4: any;

  layers: any = [];

  layers2: any = [];

  layers3: any = [];

  layers4: any = [];

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  ngOnInit(): void {
    this.isDesktop = this.deviceService.isDesktop();


    setTimeout(() => {
      this.route.params.subscribe((params) => {
        this.getDomain();
        // if (params['id']) {
        //   this.iMobileDomain = params['id'];

        // }
        this.dataFrom.controls["date"].setValue("");
        if (this.dataService.dashbordAddData) {
          this.iMobileDomain = this.dataService.dashbordAddData.iMobileDomain;
          this.tiMobileGroup = this.dataService.dashbordAddData.tiMobileGroup;
          this.tiGPSType = this.dataService.dashbordAddData.tiGPSType;
          this.taxiADS = this.dataService.dashbordAddData.iTaxiADS;
          this.dataFrom.controls["date"].setValue(this.dataService.dashbordAddData.dataFrom);
          this.dataTo.controls["date"].setValue(this.dataService.dashbordAddData.dataTo);
        }
        this.getGroup();
        this.getGpsType();
        this.getCarAreaService();
        this.getAccordingMobileGroup();
        this.getAccordingMobileDomain();
        this.getServiceAVGS();
        this.getAddsList();

      })
    }, 300);

    setTimeout(() => {

      this.source = new VectorSource({ wrapX: false });

      this.source2 = new VectorSource({ wrapX: false });

      this.source3 = new VectorSource({ wrapX: false });

      this.source4 = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      this.vector2 = new VectorLayer({

        source: this.source2,

      });

      this.vector3 = new VectorLayer({

        source: this.source3,

      });

      this.vector4 = new VectorLayer({

        source: this.source4,

      });

      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
        this.layers2.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
        this.layers3.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
        this.layers4.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
          this.layers2.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
          this.layers3.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
          this.layers4.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );

        }

        this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector)

        this.layers2.push(new TileLayer({ source: new OSM({}) }), this.vector2)

        this.layers3.push(new TileLayer({ source: new OSM({}) }), this.vector3)

        this.layers4.push(new TileLayer({ source: new OSM({}) }), this.vector4)
      }

      this.map = new Map({
        target: "map1",
        view: new View({
          zoom: 4,
          center: olProj.fromLonLat(this.location)
        }),
        layers: this.layers
      });
      this.map2 = new Map({
        target: "map2",
        view: new View({
          zoom: 4,
          center: olProj.fromLonLat(this.location)
        }),
        layers: this.layers2
      });
      this.map3 = new Map({
        target: "map3",
        view: new View({
          zoom: 4,
          center: olProj.fromLonLat(this.location)
        }),
        layers: this.layers3
      });
      this.map4 = new Map({
        target: "map4",
        view: new View({
          zoom: 4,
          center: olProj.fromLonLat(this.location)
        }),
        layers: this.layers4
      });
      this.clusterData();

    }, 300);


  }
  ngAfterViewInit(): void {

  }
  getGpsType = async () => {
    const resp = await axios.post(
      `GetGPSType`
    );
    this.carType = resp.data;
  }
  search() {
    this.dataService.dashbordAddData = {
      dataFrom: this.dataFrom.controls["date"].value,
      dataTo: this.dataTo.controls["date"].value,
      iMobileDomain: $("#domainDashbord").val(),
      tiMobileGroup: $("#carGroup").val(),
      tiGPSType: $("#carType").val(),
      iTaxiADS: $("#taxiADS").val(),
    }
    setTimeout(() => {
      this.reloadCurrentRoute();
    }, 50);
  }
  // changeDomain(val: any) {
  //   this.iMobileDomain = val.value;


  //   //this.router.navigateByUrl(`/dashbord/${val.value}`);

  //   setTimeout(() => {
  //     this.reloadCurrentRoute(val.value);
  //   }, 50);
  // }
  goBack() {
    this.router.navigateByUrl(`/`);;
  }
  getAddsList = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    const resp = await axios.post(`Taxi_ListTaxiAds`, model);
    resp.data = JSON.parse(resp.data);
    this.listTaxiAdds = resp.data;

  }

  getCarAreaService = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileGroup = this.tiMobileGroup;
    model.tiGPSType = this.tiGPSType;
    model.iTaxiADS = this.taxiADS;

    const resp = await axios.post(`TaxiADS_Audience`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '41' } });

      return;
    }
    this.obj = resParse;
    this.label = [];
    this.datachart = [];
    this.obj.forEach((element: any) => {
      this.label.push(element.X);
      this.datachart.push(element.Y);
    });
    const ctx = document.getElementById('myChart2') as any;
    if (this.ctx1) {
      this.ctx1.destroy();
    }
    this.ctx1 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label,
        datasets: [
          {
            // label: '# of Votes',
            data: this.datachart,
            backgroundColor: Object.values(this.CHART_COLORS),

            borderWidth: 1,
          },
        ],
      },
      options: {
        onClick: (e) => {
          const points = this.ctx1.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);
          const firstPoint = points[0];
          const label = this.ctx1.data.labels[firstPoint.index];
          const value = this.ctx1.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
          this.fileName = "نمودار خودرو به تفکیک حوزه.xlsx";
          this.carStatus(2, label);
        },
        responsive: true,

        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
            labels: {
              color: "black",
            }
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          title: {
            display: false,
          },
        },
        scales: {

          x: {
            ticks: {
              color: 'black',

              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
              //size: 30
            }
          },

        }
      },

    });

  }

  getGroup = async () => {
    const resp = await axios.post(`GetMobileGroup`, {});
    resp.data = JSON.parse(resp.data);
    this.groupCar = resp.data;
  };


  getAccordingMobileGroup = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileGroup = this.tiMobileGroup;
    model.tiGPSType = this.tiGPSType;
    model.iTaxiADS = this.taxiADS;
    model.strSDate = this.dataFrom.controls["date"].value;
    model.strEDate = this.dataTo.controls["date"].value;
    const resp = await axios.post(`TaxiADS_According2MobileGroup`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '42' } });

      return;
    }
    this.obj14 = resParse;
    this.label14 = [];
    this.datachart14 = [];
    this.obj14.forEach((element: any) => {
      this.label14.push(element.X);
      this.datachart14.push(element.Y);
    });
    const ctx = document.getElementById('myChart16') as any;
    if (this.ctx16) {
      this.ctx16.destroy();
    }
    this.ctx16 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label14,
        datasets: [
          {
            label: '',
            data: this.datachart14,
            backgroundColor: Object.values(this.CHART_COLORS3),

          },
        ],

      },

      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },

          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      },
    });
  }
  getAccordingMobileDomain = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileGroup = this.tiMobileGroup;
    model.tiGPSType = this.tiGPSType;
    model.iTaxiADS = this.taxiADS;
    model.strSDate = this.dataFrom.controls["date"].value;
    model.strEDate = this.dataTo.controls["date"].value;
    const resp = await axios.post(`TaxiADS_According2MobileDomain`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '43' } });

      return;
    }
    this.obj16 = resParse;
    this.label16 = [];
    this.datachart16 = [];
    this.obj16.forEach((element: any) => {
      this.label16.push(element.X);
      this.datachart16.push(element.Y);
    });
    const ctx = document.getElementById('myChart18') as any;
    if (this.ctx18) {
      this.ctx18.destroy();
    }
    this.ctx18 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label16,
        datasets: [
          {
            label: '',
            data: this.datachart16,
            backgroundColor: Object.values(this.CHART_COLORS),

          },
        ],

      },

      options: {
        onClick: (e) => {
          const points = this.ctx18.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);
          const firstPoint = points[0];
          const label = this.ctx18.data.labels[firstPoint.index];
          const value = this.ctx18.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
          this.fileName = "سال ساخت.xlsx";
          this.carStatus(7, label);
        },
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },

          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      },
    });
  }
  getServiceAVGS = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileGroup = this.tiMobileGroup;
    model.tiGPSType = this.tiGPSType;

    const resp = await axios.post(`Taxi_ServiceAVGS`, model);
    this.serviceAVGS = JSON.parse(resp.data);
  }

  timeSlotEdit(event: any, array: any) {
    let activeElement = this.ctx9.current.getElementAtEvent(event);
  }
  newOpenMap() {
    this.map = new Map({
      interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
      target: 'test',
      layers: [
        new TileLayer({
          source: new OSM({}),
        })
      ],
      view: new View({
        center: olProj.fromLonLat(this.location),
        zoom: 5,
      }),
    });

    //context menu
  }
  clusterData = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileGroup = this.tiMobileGroup;
    model.tiGPSType = this.tiGPSType;
    model.iTaxiADS = this.taxiADS;

    const resp = await axios.post(`TaxiADS_Location`, model);

    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '44' } });

      return;
    }

    this.clustersLayer(resParse);
  }



  clustersLayer(data: any) {

    setTimeout(() => {
      this.map.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }

        var el = this.mapService.mapPointerMove(
          this.map.getEventPixel(e.originalEvent),
          this.map
        );
        //this.showData(el);
        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.map.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;

    // Addfeatures to the cluster
    let addFeatures = (nb: any) => {
      var ext = this.map.getView().calculateExtent(this.map.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          // new Point (this.mapService.transformCoordinates2([
          //   data[i].dLongitude,
          //   data[i].dLatitude])

          // ),
          // data: data,
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([
            data[i].fLon,
            data[i].flat])

          ),
          id_: data[i].strUnitId,
          data: {
            Id: data[i].strUnitId,
            strFullName: data[i].strFullName,
            strDate: data[i].strDate,
            strMobile: data[i].strMobile,
            strTime: data[i].strTime,
            strVehicleNo: data[i].strVehicleNo,
            strMobileType_strComment: data[i].strMobileType_strComment,


            // html: `${data[i].strFullName}`,
          },
        });
        features[i].set("id", i);
      }
      clusterSource.getSource().clear();
      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.map.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.map.addInteraction(selectCluster);


  }

  getDomain = async () => {
    const resp = await axios.post(
      `GetMobileDomain4Report?iSystemUser=${localStorage.getItem("ID")}`,
      {}
    );
    this.domain = JSON.parse(resp.data);
    if (this.iMobileDomain) {
      setTimeout(() => {
        $("#domainDashbord").val(Number(this.iMobileDomain));

      }, 100);
    }
    if (this.tiMobileGroup) {
      setTimeout(() => {
        $("#carGroup").val(Number(this.tiMobileGroup));

      }, 100);
    }

    if (this.tiGPSType) {
      setTimeout(() => {
        $("#carType").val(Number(this.tiGPSType));

      }, 100);
    }
    if (this.taxiADS) {
      setTimeout(() => {
        $("#taxiADS").val(Number(this.taxiADS));

      }, 100);
    }
  }
  reloadCurrentRoute() {
    let currentUrl = `/dashbordAdds`;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
  guid(Id: any) {
    this.otherService.guid(Id);
  }
  carStatus = async (tiChart: any, strValue: any) => {
    var model = {
      iSystemUser: localStorage.getItem("ID"),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      iMobileDomain: this.iMobileDomain,
      tiMobileGroup: this.tiMobileGroup,
      tiGPSType: this.tiGPSType,
      tiChart: tiChart,
      strValue: strValue
    }
    this.otherService.Showspinner();
    const resp = await axios.post(
      `GetMobileListBaseChartStatus`,
      model
    );
    this.otherService.nonespinner();
    $('#CarStatusModal').modal('show');
    this.carStatusData = JSON.parse(resp.data);
  }
  //excel Repotr
  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }
}
